import React from "react";
import styled, { css } from "styled-components";

export default styled.span.withConfig({
  displayName: "Icon",
  componentId: "zjcn7o-0"
})(["display:inline-block;font-size:1.5em;line-height:1;width:1em;height:1em;", ";", ";", ";"], function (props) {
  return props.circular && css(["padding:0.25em;border-radius:1em;text-align:center;svg{color:", ";margin-top:-2px;width:1em;height:0.9em;}img{width:1em;height:0.85em;margin-top:0.025em;}"], function (props) {
    return props.theme.background;
  });
}, function (props) {
  return props.primary && css(["background:", ";"], function (props) {
    return props.theme.primary;
  });
}, function (props) {
  return props.secondary && css(["background:", ";"], function (props) {
    return props.theme.secondary;
  });
});